import { LinkButton, type LinkButtonProps, LinkType } from "~/common/components/Link";
import { type ReactNode } from "react";
import { forwardRef } from "react";
import classNames from "classnames";
import { styled } from "~/common/mui";

interface Props extends Omit<LinkButtonProps, "children"> {
  icon: ReactNode;
  outlinedIcon?: boolean;
  active?: boolean;
}

export const MobileNavButton = forwardRef<HTMLButtonElement, Props>(({ active, icon, outlinedIcon, className, ...rest }, ref) => {
  return (
    <StyledLinkButton
      className={classNames(
        "scha__mobile-navigation__button",
        outlinedIcon && "scha__mobile-navigation__button--outlined-icon",
        className,
      )}
      variant={active ? LinkType.PRIMARY : LinkType.NAVIGATION}
      ref={ref}
      {...rest}
    >
      {icon}
    </StyledLinkButton>
  );
});

const StyledLinkButton = styled(LinkButton)(({ theme }) => ({
  flex: "none",
  marginRight: theme.spacing(1),
  [theme.breakpoints.down("desktop-s")]: {
    height: theme.spacing(6),
    width: theme.spacing(6),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  "&.scha__link--navigation": {
    color: theme.palette.text.secondary,
  },
  "&.scha__mobile-navigation__button--outlined-icon svg": {
    outline: `1px solid ${theme.palette.divider}`,
    outlineOffset: theme.spacing(1),
    borderRadius: "50%",
  },
}));
